export default "__VITE_ASSET__C1z8wsK3__"